"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auto_all_forward = exports.auto_all_rotated = void 0;
const uuid_1 = require("uuid");
function auto_all_rotated(params, gapDistance, overhang) {
    return autoBoxLayout(params, gapDistance, true, overhang);
}
exports.auto_all_rotated = auto_all_rotated;
function auto_all_forward(autoLayerParams, gapDistance, overhang) {
    return autoBoxLayout(autoLayerParams, gapDistance, false, overhang);
}
exports.auto_all_forward = auto_all_forward;
function autoBoxLayout({ all_boxes, all_pallets, box_index, pallet_index }, gapDistance, rotated = false, overhang) {
    const SAFETY_FACTOR = 0.01;
    const { width: pwidth, length: plength } = all_pallets[pallet_index].Dimensions;
    let { width: bwidth, length: blength } = all_boxes[box_index].dimensions;
    bwidth += bwidth * SAFETY_FACTOR;
    blength += blength * SAFETY_FACTOR;
    if (rotated) {
        let tmp = bwidth;
        bwidth = blength;
        blength = tmp;
    }
    let layout = {
        name: rotated ? 'All Rotated' : 'All Forward',
        id: String((0, uuid_1.v4)()),
        box_id: '',
        boxPositions: [],
        gapDistance,
        overhang,
    };
    let totalAllowedWidth = pwidth;
    let totalAllowedLength = plength;
    totalAllowedWidth += overhang * 2;
    totalAllowedLength += overhang * 2;
    if (gapDistance !== undefined) {
        totalAllowedWidth += gapDistance;
        totalAllowedLength += gapDistance;
    }
    let x;
    let y;
    // center of mass
    let com_x = 0;
    let com_y = 0;
    let i = 0;
    let j = 0;
    const maxBoxesWidth = Math.floor(totalAllowedWidth / bwidth);
    const maxBoxesLength = Math.floor(totalAllowedLength / blength);
    for (i = 0; i < maxBoxesWidth; i++) {
        for (j = 0; j < maxBoxesLength; j++) {
            x = (i * bwidth) / pwidth;
            y = (j * blength) / plength;
            com_x += x + bwidth / (2 * pwidth);
            com_y += y + blength / (2 * plength);
            layout.boxPositions.push({
                rotated,
                index: box_index,
                position: { x, y },
            });
        }
    }
    com_x /= layout.boxPositions.length;
    com_y /= layout.boxPositions.length;
    //  align to center of pallet (0.5, 0.5).
    let d_x = com_x - 1 / 2;
    let d_y = com_y - 1 / 2;
    layout.boxPositions.forEach((bp) => {
        bp.position.x -= d_x;
        bp.position.y -= d_y;
    });
    return layout;
}
